import { useTranslation } from "react-i18next"



export const PasswordRulesModule = ({ password }) => {
    const { t } = useTranslation('settings')

    return (
        <div className="flex flex-col text-gray-800 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-500 border max-w-[320px] p-2 rounded-lg text-nowrap text-sm max-h-max">

            <span className="">{t('The password should contain:')}</span>
            <ul className=" list-disc list-inside ">
                <li className={`${password && password.length >= 8 && "text-green-600"} `}>{t('At least 8 characters,')}</li>
                <li className={`${password && /[A-Z]/.test(password) && "text-green-600"}`}>{t('At least 1 upper-case letter,')}</li>
                <li className={`${password && /[a-z]/.test(password) && "text-green-600"}`}>{t('At least 1 lower-case letter,')}</li>
                <li className={`${password && /[0-9]/.test(password) && "text-green-600"}`}>{t('At least 1 number,')}</li>
                <li className={`${password && /[!@#$%^&*(),.?":{}|<>]/.test(password) && "text-green-600"} text-wrap max-w-64`}>{t('At least 1 unique character (e.g., !@#%^)')}</li>
            </ul>
        </div>
    )
}


export const UsernameRulesModule = ({ username }) => {
    const { t } = useTranslation('settings')

    return (
        <div className="flex flex-col text-gray-800 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-500 border max-w-max p-2 rounded-lg text-nowrap text-sm max-h-max">

            <span className="">{t('The username:')}</span>
            <ul className=" list-disc list-inside ">
                {/* <li className={`${username && username.length >= 8 && "text-green-600"} `}>At least 8 characters,</li> */}
                <li className={`${username && !/@/.test(username) && "text-green-600"}`}>{t('Should not contain the @ character,')}</li>
                <li className={`${username && !/\s/.test(username) && "text-green-600"}`}>{t('Should not contain any whitespaces,')}</li>
                <li className={`${username && username.length > 0 && "text-green-600"}`}>{t('Should not be empty,')}</li>
                <li className={"text-blue-600"}>{t('Should be unique.')}</li>
            </ul>
            <span className=" text-wrap max-w-64">{t('The characters violating these conditions will be removed.')}</span>

        </div>
    )
}